import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import messages from '../../../../res/translations/messages';

class ChannelInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    render() {
        const {channel, children, values} = this.props;
        const enabled = !!(values && values.enabled);
        return (
            <button type="button" className="btn btn-sm btn-outline-secondary" disabled={!enabled} onClick={this.toggleModal}>
                <FormattedMessage {...messages.buttons.channelInfo} />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.channels[channel]} />
                    </ModalHeader>
                    <ModalBody>
                        {children}
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-primary" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Modal>
            </button>
        );
    }
}

export default ChannelInfo;
